import { getTransactionId } from '../../common/data';
import { axiosWithToken, callFesWithLoading } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const startIdentProcess = async (customerRole: string): Promise<any> => {
  const dataStorageId = getTransactionId();
  return callFesWithLoading.post(`ident/${REACT_APP_BACKEND_BRAND}/${dataStorageId}/start`, { customerRole }, true);
};

export const startDashboardIdent = async (dataStorageId: string, customerRole: string): Promise<any> => {
  const url = `${REACT_APP_API_GATEWAY}/ident/${REACT_APP_BACKEND_BRAND}/${dataStorageId}/start`;

  return axiosWithToken
    .post(url, { customerRole })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
